<script>
  import * as firebase from "firebase/app";

  import Button from "./Button.svelte";
  import CookieBanner from "./CookieBanner.svelte";
  import Segment from "./Segment.svelte";
  import Card from "./Card.svelte";
  import DistanceInfo from "./DistanceInfo.svelte";
  import Carousel from "./Carousel.svelte";
  import Logo from "./Logo.svelte";
  import Facebook from "./Facebook.svelte";
  import Twitter from "./Twitter.svelte";
  import { red, white } from "./constants";
</script>

<style>
  p {
    font-size: 1.25rem;
    grid-row: 1;
    grid-column: 1 / span 5;
    margin: 0.475rem 0;
  }

  .logo-wrapper {
    grid-column: 2 / 4;
    grid-row: 2;
    max-width: 50px;
  }

  .hashtag-wrapper {
    text-align: center;
    grid-column: 5 / 9;
    grid-row: 2;
  }

  .hashtag-wrapper p {
    margin: 0;
  }

  .red-text{
    color: #ed1c24;
  }

  .text-with-background {
    display: inline;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    background-color: #f9df9b;
    box-shadow: 0.5rem 0 0 #f9df9b, -0.5rem 0 0 #f9df9b;
    box-decoration-break: clone;
    line-height: 2rem;
    color: #ed1c24;
    font-weight: bold;
  }

  a {
    color: inherit;
    font-size: inherit;
  }

  .h1-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    grid-column: 3 / span 8;
    grid-row: 4 / span 8;
    text-align: center;
    padding-bottom: 1.5rem;
  }

  .footer {
    background: #222729;
    color: white;
    grid-column: 1 / span 12;
    grid-row: 2 / span 12;
  }

  .footer p {
    margin: 1rem 0;
  }

  .footer h1 {
    color: #ed1c24;
  }

  .footer-column {
    grid-row: 3 / span 12;
    padding: 10%;
  }

  .footer-column:nth-of-type(1) {
    grid-column: 3 / span 3;
  }

  .footer-column:nth-of-type(2) {
    grid-column: 7 / span 3;
  }

  .footer-column:nth-of-type(3) {
    grid-column: 10;
  }

  .footer-logo {
    max-width: 50px;
  }

  .card-section {
    padding: 0 1.25rem;
    position: relative;
  }

  .card-section p {
    padding: 0 2rem;
  }

  .card-section.darker {
    background-color: #f9df9b;
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .card-section h2 {
    font-weight: 900;
    font-size: 2.6rem;
  }

  .bg {
    position: absolute;
    width: 180vh;
    top: -110vh;
    left: 50%;
    z-index: -1;
    transform: translateX(-50%);
    transition: opacity 0.3s ease;
  }

  .share-wrapper {
    display: inline-grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 0.5rem;
    padding-top: 1rem;
  }

  @media screen and (min-width: 640px) {
    .logo-wrapper {
      grid-column: 3 / 4;
      max-width: 80px;
    }

    .footer-logo {
      max-width: 80px;
    }

    .h1-wrapper {
      grid-column: 4 / span 6;
    }

    .h1-wrapper h1 {
      font-size: 6rem;
    }

    .footer-column {
      padding: initial;
    }

    .card-section {
      padding: 0 4rem;
    }

    .h1-description-wrapper {
      max-width: 75%;
    }
  }

  @media screen and (min-width: 1280px) {
    .card-section {
      padding: 0 6rem;
    }
  }

  @media screen and (min-width: 1600px) {
    .card-section {
      padding: 0 6rem;
    }
  }
</style>

<Segment
  style="grid-template-rows: auto; padding-top: 2rem; padding-bottom: 2rem;">
  <div class="logo-wrapper">
    <Logo />
  </div>
  <div class="h1-wrapper">
    <img src="header.png" width="100%" alt="" />
    <div class="h1-description-wrapper">
      <p class="text-with-background">
        Gemensam Pride-parad men på varsitt håll. Promenera själv eller ta någon du tycker om i handen och promenera tillsammans. Detta gör vi i solidaritet med alla HBTQI-personer som inte kan visa sin kärlek öppet.
        <a href="#hallahander" target="_self">Läs mer</a>
      </p>
    </div>  
  </div>
  <div class="hashtag-wrapper">
    <p>
      <b class="text-with-background">#Hållminhand</b>
    </p>
  </div>
</Segment>

<Segment style="grid-template-rows: auto;">
  <Card>
    <div class="card-section" style="padding-bottom: 2rem;">
      <DistanceInfo />
      <br />
      <br />
      <p>
        <b>1. Ta en promenad, på egen hand eller hand i hand med någon.</b>
      </p>
      <p>
        <b>2. Lägg upp en bild från promenaden på sociala medier med taggen <span class="red-text">#hållminhand</span></b>
      </p>
      <p>
        <b>3. Registrera din sträcka här på hemsidan och uppmana fler att promenera i solidaritet med alla som inte kan hålla sin partner i hand offentligt</b>
      </p>
      <Carousel />  
    </div>
    <div class="card-section darker" id="hallahander">
      <h2>Det känns konstigt att inte hålla nån du gillar i handen...</h2>
      <p>
        ...men för många är den sociala distansen vardag. I
        <a
          href="https://fra.europa.eu/en/publication/2020/eu-lgbti-survey-results">
          6 av 10 EU-länder undviker HBTQI-personer att hålla handen offentligt.
        </a>
        HBTQI-personers rättigheter inskränks världen över. Vänsterpartiet kämpar bland annat för en
        mer progressiv lagstiftning kring föräldraskap, transpersoners
        rättigheter och rätten till asyl för HBTQI-flyktingar.
      </p>

      <br />
      <br />

      <Button href="https://www.vansterpartiet.se/politik/hbtq" outline={true}>
        V:S HBTQ-POLITIK
      </Button>
      <br />
      <br />
      <Button
        href="https://www.facebook.com/events/295009869019453"
        outline={true}>
        V:S PRIDE-PROGRAM 2021
      </Button>
    </div>
    <div class="card-section darker" id="share">
      <p>
        <b>DELA SIDAN</b>
      </p>
      <div class="share-wrapper"> 
        <Facebook />
        <Twitter />
      </div>
    </div>
  </Card>
</Segment>

<Segment fullWidth={true}>
  <div class="footer">
    <Segment noGridOnMobile={true}>
      <div class="footer-column">
        <h1>Vänsterpartiet Storstockholm</h1>
        <p style="margin: 2rem 0;">
          Vänsterpartiet arbetar för att skapa ett samhälle för alla – inte bara
          några få. Det är många som pratar om jämlikhet men vi gör något åt
          saken. Vi är det parti som driver en politik som faktiskt ökar
          jämlikheten. Tillsammans skapar vi ett samhälle för alla.
        </p>
        <Button href="http://vansterpartietweb.azurewebsites.net/#/newregister">
          Bli medlem
        </Button>
      </div>
      <div class="footer-column">
        <h1>Kontakt</h1>
        <p>
          <b>Postadress</b>
        </p>
        <p>Box 12660, 112 93 Stockholm</p>
        <p>
          <b>Telefon</b>
        </p>
        <p>08-654 13 10</p>
        <p>
          <b>E-post</b>
        </p>
        <p>
          <a href="mailto:storstockholm@vansterpartiet.se">
            storstockholm@vansterpartiet.se
          </a>
        </p>
      </div>
      <div class="footer-column footer-logo">
        <Logo />
      </div>
    </Segment>
  </div>
</Segment>

<CookieBanner />
